import { formatUtcDate } from "@utility/utilityFunctions";

export default function displayDate(d: string | Date | undefined | null) {
  return d && d !== "---" ? formatUtcDate(d) : "";
}
